import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Icon, Loader } from "semantic-ui-react";
import { addPartiesTabWarnings, deletePartiesTabWarnings } from "../../../commonActions/serverErrorAction";
import InputField from "../../../commonComponents/formComponents/inputField";
import {
  deleteGuaranteeInfo, saveGuaranteeInfoFeild, updateGuaranteeInfoFeild
} from "../../actions";
import { getValidationError } from "../../Helper";

function GuaranteeDocumentsDetails(props) {
  const dispatch = useDispatch();
  const addErrors =(level, value, fieldName)=>{
    dispatch(addPartiesTabWarnings(level, value, fieldName));
   };
    const deleteErrors=(level, value, fieldName)=>{
      dispatch(deletePartiesTabWarnings(level, value, fieldName));
    };

  const info = useSelector(
    (state) => state.Shipment.warranties[props.infoIndex]
  );

  const [isRemoving, setIsRemoving] = useState(false);

  const updateRemoveFlag = () => {
    setIsRemoving(false);
  };

  const {
    infoIndex,

    totalInfo,
    warrantyId,

    isFormDisabled,
  } = props;

  return (
  
      <Grid.Row>
        <Grid.Column
          width="15"
          className="divFormFeild border-bottom  "
        >
           <InputField
            isLabel={false}
            id={`ref-Header-${infoIndex}-headeradditionalInfo`}
            type="text"
            label={"GRN"}
            value={info.warrantyReferences}
            errors={getValidationError("warrantyReferences", info.warrantyReferences, "partiesTab")}
            className={"field-bg"}
            clearInput={false}
            disabled={isFormDisabled}
            onChange={(value) => {
              dispatch(updateGuaranteeInfoFeild(warrantyId,infoIndex, {'warrantyReferences': value}))

            }}
            onBlur={(value) => {
              dispatch(saveGuaranteeInfoFeild(warrantyId, 'warrantyReferences'))
              let err = getValidationError(
                "warrantyReferences",
                info.warrantyReferences,
                "partiesTab"
              );
              err.length
                ?addErrors("partiesTab",err[0],"warrantyReferences")
                :deleteErrors
                    ("partiesTab","","warrantyReferences");
            }}
          />
        </Grid.Column>

      
        <Grid.Column width="1" className="icon-delete-add-info">
          {!isRemoving ? (
            <span>
              {totalInfo > 0 && (
                <Icon
                  id={`removeGrn-${infoIndex}`}
                  name="trash alternate outline"
                  onClick={() => {
                    setIsRemoving(true);
                    dispatch(
                      deleteGuaranteeInfo(
                        info.warrantyId,
                        infoIndex,
                        updateRemoveFlag
                      )
                    );
                 
                  }}
            //      disabled={isFormDisabled || isRemoving}
                />
              )}
            </span>
          ) : (
            <span className="delete-info-loader">
              <Loader
                active
                inline
                size="mini"
                style={{ marginRight: "10px" }}
              />
            </span>
          )}
        </Grid.Column>
      </Grid.Row>
   
  );
}

export default React.memo(GuaranteeDocumentsDetails)
